import * as UnitDivide from "../unit-divide";
import { Liter } from "./volume";
import { KiloWattHour } from "./energy2";
/// Water use efficiency
export var LiterPerKiloWattHour = UnitDivide.volumeByEnergy("LiterPerKiloWattHour", Liter, KiloWattHour);
//# sourceMappingURL=water-use-efficiency.js.map